import axios from '../merchantPortalService';
import { Application } from 'src/@types/application-types';
import { PaymentHistory } from 'src/@types/payment-history';
import { UpcomingPayments } from 'src/@types/upcoming-payments';

export const fetchDeals = async () => {
  try {
    const response = await axios.get('/api/v1/deals');
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }

  return null;
};

export const requestPayoffLetter = async (
  clientId: string,
  username: string,
  fundingId: string,
  dealId: string
) => {
  try {
    const response = await axios.post(`/api/v1/deals/${clientId}/payoffLetter`, {
      username,
      fundingId,
      dealId,
    });

    if (response.data) {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

export const requestZeroBalanceLetter = async (
  clientId: string,
  username: string,
  fundingId: string,
  dealId: string
) => {
  try {
    const response = await axios.post(`/api/v1/deals/${clientId}/zeroBalanceLetter`, {
      dealId,
      username,
      fundingId,
    });

    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }

  return {
    message: 'Unable to request Zero Balance Letter',
  };
};

export const requestRenewal = async (
  clientId: string,
  username: string,
  fundingId: string,
  dealId: string
) => {
  try {
    const response = await axios.post(`/api/v1/deals/${clientId}/renewal`, {
      dealId,
      username,
      fundingId,
    });

    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }

  return {
    message: 'Unable to request renewal',
  };
};

export const requestPaymentHistory = async (dealId: string) => {
  try {
    const { data } = await axios.get<PaymentHistory[]>(`/api/v1/deals/${dealId}/paymentHistory`);
    return data;
  } catch (error) {
    console.error(error);
    throw new Error('Unable to load remittance history');
  }
};

export const requestUpcomingPayments = async (dealId: string) => {
  try {
    const { data } = await axios.get<UpcomingPayments[]>(
      `/api/v1/deals/${dealId}/upcomingPayments`
    );
    return data;
  } catch (error) {
    console.error(error);
    throw new Error('Unable to load upcoming payments');
  }
};

export const getRemittanceDetails = async (fundingId: string) => {
  try {
    const { data } = await axios.get<PaymentHistory[]>(
      `/api/v1/deals/${fundingId}/remittance-details`
    );
    return data;
  } catch (error) {
    console.error(error);
    throw new Error('Unable to load remittance history');
  }
};

export const getFundedDealsByCompanyId = async (companyId: string) => {
  try {
    const response = await axios.get(`/api/v1/fundedDeals/${companyId}`);
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }

  return [];
};

export const getFundedDealFromMCAFunds = async (application: Application) => {
  try {
    const response = await axios.get(`/api/v1/fundedDeal/${application.appId}`);
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }

  return [];
};
